import React from 'react';
import { defineMessages, T } from '@sm/intl';
import { Container, Typography } from '@sm/wds-react';

import { SocialName } from './types';

export const TEST_ID = 'UnlinkedMessaging';

const COPY = defineMessages({
  unlinkedPageHeader: {
    id: 'login.UnlinkedMessaging.Header',
    defaultMessage: "Your {socialName} account isn't linked to a SurveyMonkey account",
    description:
      '[Type: Header][Vis: med] - Header of the page alerting the user their third party account is unlinked',
  },
});

export default function UnlinkedMessaging({ socialName }: { socialName: SocialName }): JSX.Element {
  return (
    <Container className="sm-unlinked-page sm-unlinked-page__message-container wds-p-b-3" data-testid={TEST_ID}>
      <Typography className="wds-p-b-3" variant="pageTitle">
        <T desc={COPY.unlinkedPageHeader} values={{ socialName }} />
      </Typography>
    </Container>
  );
}
